import classNames from 'classnames';

import { AiIcon } from '@carboncopyco/icons';
import { ColorHex, TextBase, TooltipBubble } from '@carboncopyco/ui';
import { RuleIcon } from '../RuleIcon';
import { RulePreview } from '../RulePreview';
import { TextTitleWithTooltip } from '../RulePreview/RulePreview';
import type { Rule } from './types';

type AIRulePreviewProps = {
  rule: Rule;
  isDisabled?: boolean;
  getAllSubGroupModifications?: (arg0: string) => any;
  isHighlighted?: boolean;
  tooltipMessage?: string;
};

export const AIRulePreview = ({
  rule,
  isDisabled = false,
  getAllSubGroupModifications,
  isHighlighted,
  tooltipMessage,
}: AIRulePreviewProps) => {
  return (
    <RulePreview>
      <div
        className={classNames('flex flex-shrink-0 min-w-0', {
          'bg-ds-accent-100': isDisabled,
        })}
      >
        <TooltipBubble
          title={tooltipMessage}
          placement="top"
          disabled={!tooltipMessage?.length || !isHighlighted}
        >
          <RuleIcon
            size="md"
            borderColor={isHighlighted ? 'border-ds-primary-300' : null}
          >
            <AiIcon
              color={isDisabled ? ColorHex.natural200 : undefined}
              size={24}
            />
          </RuleIcon>
        </TooltipBubble>
      </div>
      <div className="flex gap-1 shrink min-w-0">
        <div className="flex-grow shrink min-w-0 truncate">
          <TextTitleWithTooltip
            label={rule.content.name}
            isDisabled={isDisabled}
          />
        </div>
        <div>
          {getAllSubGroupModifications && (
            <TextBase
              label={`(${getAllSubGroupModifications(rule.content.id).length})`}
              color={isDisabled ? 'text-ds-natural-200' : 'text-ds-natural-300'}
            />
          )}
        </div>
      </div>
    </RulePreview>
  );
};
